import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { planManagementQueries } from '@/services/planManagement/planManagement.queries';

export const useGetAdminPlanDetail = (clubId: string, planId: string) => {
  const { data: adminPlanDetails, isLoading } = useQuery({
    ...planManagementQueries.adminPlanDetail({ clubId, planId }),
    enabled: !!clubId && !!planId,
  });

  return {
    adminPlanDetails: adminPlanDetails?.data,
    isLoading,
  };
};
